"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sanitizeForJSON;
exports.whitespaceToSpace = exports.quotesFromDoubleToSlanted = exports.quotesFromSlantedToDouble = void 0;

var _flow = _interopRequireDefault(require("lodash/flow"));

var _trim = _interopRequireDefault(require("lodash/trim"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WHITESPACE_CHAR_REGEX = /\t|\r|\n/g;
var RIGHT_DOUBLE_QUOTE_ENTITY = "\u201D";
var SLANTED_DOUBLE_QUOTE_REGEX = new RegExp("/".concat(RIGHT_DOUBLE_QUOTE_ENTITY, "/"), 'g');

var quotesFromSlantedToDouble = function quotesFromSlantedToDouble() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(SLANTED_DOUBLE_QUOTE_REGEX, '"');
};

exports.quotesFromSlantedToDouble = quotesFromSlantedToDouble;

var quotesFromDoubleToSlanted = function quotesFromDoubleToSlanted() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/"/g, RIGHT_DOUBLE_QUOTE_ENTITY);
};

exports.quotesFromDoubleToSlanted = quotesFromDoubleToSlanted;

var whitespaceToSpace = function whitespaceToSpace() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(WHITESPACE_CHAR_REGEX, ' ');
};

exports.whitespaceToSpace = whitespaceToSpace;

function sanitizeForJSON(str) {
  if (typeof str !== 'string') {
    return JSON.stringify(str);
  }

  return (0, _flow.default)(_trim.default, whitespaceToSpace, quotesFromDoubleToSlanted)(str);
}

//# sourceMappingURL=sanitizeForJson.js.map